import { Box } from '@skin-seoul/design-system';
import React from 'react';
import { LucideIcon } from '../../components';
import type { IconVariant } from '@skin-seoul/service';

interface CheckIconProps {
  achieved: boolean;
  /** Icon variant - 'check' shows checkmark (24px), 'dot' shows small circle (12px) */
  variant?: IconVariant;
}

export function CheckIcon({ achieved, variant = 'check' }: CheckIconProps) {
  const bgColor = achieved ? 'success.600' : 'neutral.600';

  if (variant === 'dot') {
    return <Box width="12px" height="12px" bg={bgColor} borderRadius="6px" />;
  }

  return (
    <Box
      width="24px"
      height="24px"
      bg={bgColor}
      display="flex"
      alignItems="center"
      borderRadius="12px"
      justifyContent="center"
    >
      <LucideIcon name="Check" strokeWidth={2.4} color="generic.0" boxSize={4} />
    </Box>
  );
}
